import { api, router, state } from '../state.js';
import { emptyState } from './ui/index.js';

/**
 * <arc-home> — where the console lands: the person's community (the one
 * remembered, their default, or the first they may open) and its home page.
 * Someone with no community is told so.
 */
class ArcHome extends HTMLElement {
  async connectedCallback() {
    this.innerHTML = `<div class="loading-center"><div class="spinner"></div></div>`;
    if (!state.sites.length) {
      try {
        const res = await api.sites.list();
        state.sites = res.items ?? [];
        state.defaultSiteId = res.default_site_id ?? null;
      } catch (err) {
        this.innerHTML = emptyState({ icon: 'warning', title: 'Could not load your communities', text: err.message, tone: 'error' });
        return;
      }
    }
    let remembered = null;
    try { remembered = localStorage.getItem('arc_site'); } catch {}
    const site = state.sites.find(s => s.slug === remembered)
      ?? state.sites.find(s => s.id === state.defaultSiteId)
      ?? state.sites[0];
    if (!site) {
      const admin = state.user?.is_super_admin || (state.user?.permissions ?? []).includes('Admin');
      this.innerHTML = emptyState({ icon: 'community', title: 'No community yet',
        text: admin ? 'There are no communities. Add one to start.' : 'You have not been given access to a community. Ask an administrator.',
        action: admin ? { label: 'Communities', href: '#/communities' } : null });
      return;
    }
    router.navigate(`/s/${encodeURIComponent(site.slug)}/home`);
  }
}

customElements.define('arc-home', ArcHome);
